// WCAG 4.1.2 — third-party scripts (e.g. Skroutz Analytics' hidden easyXDM iframe) append iframes without a title.
// Their markup is not ours, but a title is harmless to add and keeps axe/Lighthouse/WAVE clean.
// Only direct <body> children are watched: that is where these scripts inject, and it keeps React re-renders out of the observer.
const titleIframe = node => {
	if (node.tagName !== 'IFRAME' || node.hasAttribute('title')) return;

	let host = '';
	try {
		host = new URL(node.src).hostname;
	} catch {
		// about:blank / srcdoc frames have no host
	}
	node.setAttribute('title', host ? `${host} (third-party)` : 'Third-party frame');
};

export default function titleThirdPartyIframes() {
	document.querySelectorAll('body > iframe').forEach(titleIframe);
	new MutationObserver(mutations => mutations.forEach(m => m.addedNodes.forEach(titleIframe))).observe(document.body, { childList: true });
}
